@if (shouldShowAccordion) {
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon fontIcon="send"></mat-icon>
          {{ title }}
          <mat-panel-description>
            {{ description }}
          </mat-panel-description>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <form [formGroup]="actionFormGroup">
          @for (action of actions.controls; track action; let i = $index) {
            <div class="trigger-row">
              <div>
                @switch (getActionName(action)) {
                  @case (BullhornCreateNoteComponent.NAME) {
                    @if (entity !== 'ClientCorporation') {
                      <app-bullhorn-create-note
                        [formGroup]="action"
                        [triggerId]="triggerId"
                        (delete)="deleteAction(i)"
                      ></app-bullhorn-create-note>
                    }
                  }
                  @case (SalesforceCreateCallComponent.NAME) {
                    <app-salesforce-create-call
                      [formGroup]="action"
                      [triggerId]="triggerId"
                      (delete)="deleteAction(i)"
                    ></app-salesforce-create-call>
                  }
                  @case (UpdateFieldComponent.NAME) {
                    <app-update-field
                      [actionControl]="action"
                      [updateFieldConfig]="getActionConfig(UpdateFieldComponent.NAME)"
                      (delete)="deleteAction(i)"
                    ></app-update-field>
                  }
                }
              </div>
            </div>
          }
          <div class="footer">
            @if (createNoteAllowed(BullhornCreateNoteComponent.NAME)) {
              <button
                theme="small"
                type="button"
                class="no-squish"
                (click)="addAction(BullhornCreateNoteComponent.NAME)"
              >
                Add Create Note action
              </button>
            }
            @if (createCallAllowed(SalesforceCreateCallComponent.NAME)) {
              <button
                theme="small"
                type="button"
                class="no-squish"
                (click)="addAction(SalesforceCreateCallComponent.NAME)"
              >
                Add Create Call action
              </button>
            }
            @if (updateFieldAllowed(UpdateFieldComponent.NAME)) {
              <button
                theme="small"
                type="button"
                class="no-squish"
                (click)="addAction(UpdateFieldComponent.NAME)"
              >
                Add Update Field action
              </button>
            }
            @if (actions.controls.length === 0) {
              <div class="no-actions">No Actions</div>
            }
          </div>
        </form>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
}
